module.exports = __webpack_public_path__ + "img/world-cup.56c93d2e.svg";